import type {FC} from 'react';

import {observer} from 'mobx-react';

import type {ClickableClickEventAction} from '../../../../uikit/Clickable/types';
import type {Props} from './types';

import CloseSvg from '../../../../assets/icons/primary/Close Square.svg';
import {Icon} from '../../../../uikit/Icon';
import * as S from './styles';

export const ModalHeader: FC<Props> = observer(
  ({
    afterTitleSlot,
    isClosable,
    modalPadding,
    onRequestClose,
    renderCloseIcon: renderCloseIconProp,
    title,
    wrapperId,
  }) => {
    const shouldSkip = !title && !afterTitleSlot;

    if (shouldSkip) {
      return null;
    }

    const handleClose = (action: ClickableClickEventAction) => {
      onRequestClose(action.event.DOMEvent!);
    };

    const renderCloseIcon =
      renderCloseIconProp ??
      (() => <Icon color={'icon.gray'} size={'sm'} svg={CloseSvg} />);

    return (
      <S.Wrapper id={wrapperId}>
        <S.Container modalPadding={modalPadding}>
          <S.Content>
            {title && typeof title === 'function' ? (
              title()
            ) : (
              <S.Text>{title}</S.Text>
            )}
          </S.Content>
          {isClosable ? (
            <S.Close onClick={handleClose}>{renderCloseIcon()}</S.Close>
          ) : null}
        </S.Container>
        {afterTitleSlot?.()}
      </S.Wrapper>
    );
  },
);
